import React__default from 'react';
import classnames from 'classnames';
import { Button, Image } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { parseHtml } from '@grandvisionhq/utils';
import { TryOnButton } from '../../../../../VTO/components/TryOnButton/TryOnButton.js';

const FindOutSize = ({ findOutSizeCTA , findOutSizeDescription , findOutSizeImage , findOutSizeSubtitle , findOutSizeTitle , showVTOButton , onVTOStart , pushBookAppointmentClickEvent , pushVTOClickEvent ,  })=>{
    if (!findOutSizeTitle || !findOutSizeCTA || !findOutSizeImage) {
        return null;
    }
    const description = findOutSizeDescription ? parseHtml(findOutSizeDescription.value) : null;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "find-out-size"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "find-out-size__container"
    }, /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        className: "find-out-size__title"
    }, findOutSizeTitle), /*#__PURE__*/ React__default.createElement("div", {
        className: "find-out-size__subtitle"
    }, findOutSizeSubtitle), /*#__PURE__*/ React__default.createElement("div", {
        className: "find-out-size__description"
    }, description), showVTOButton ? /*#__PURE__*/ React__default.createElement(TryOnButton, {
        variant: "solid",
        onClick: ()=>{
            onVTOStart();
            pushVTOClickEvent();
        }
    }) : /*#__PURE__*/ React__default.createElement(Button, {
        key: findOutSizeCTA.link.label,
        icon: findOutSizeCTA.icon,
        className: classnames('find-out-size__button', findOutSizeCTA.link.style),
        href: findOutSizeCTA.link.url,
        caption: findOutSizeCTA.link.label,
        variant: "solid",
        onClick: ()=>pushBookAppointmentClickEvent()
    })), /*#__PURE__*/ React__default.createElement(Image, {
        alt: "find out size image",
        className: "find-out-size__image",
        url: findOutSizeImage.url
    })));
};
var FindOutSize$1 = FindOutSize;

export { FindOutSize$1 as default };
//# sourceMappingURL=FindOutSize.js.map
